import React, { useEffect, useState } from 'react';
import Card from '../../components/ui/Card';
import Btn from '../../components/ui/Btn';
import Badge from '../../components/ui/Badge';
import { Input } from '../../components/ui/Input';
import CadastroEmpresaForm from '../cadastros/CadastroEmpresaForm';
import TransporteTab from '../cadastros/tabs/TransporteTab';
import { transportadorasApi } from '../../api/transportadoras';
import { COLORS } from '../../theme';

const abaExtra = { titulo: 'Transporte', Componente: TransporteTab };

export default function TransportadorasList() {
  const [transportadoras, setTransportadoras] = useState([]);
  const [busca, setBusca] = useState('');
  const [registroAberto, setRegistroAberto] = useState(undefined);

  const carregar = () => transportadorasApi.listar(busca ? { busca } : {}).then(setTransportadoras).catch(() => {});
  useEffect(() => { carregar(); }, [busca]); // eslint-disable-line

  const alternarAtivo = async (t) => {
    const acao = t.ativo ? 'desativar' : 'reativar';
    if (!window.confirm(`Tem certeza que quer ${acao} a transportadora "${t.nome_fantasia}"?`)) return;
    await transportadorasApi.atualizar(t.id, { ativo: t.ativo ? 0 : 1 });
    carregar();
  };

  if (registroAberto !== undefined) {
    return (
      <CadastroEmpresaForm
        titulo="Transportadora"
        api={transportadorasApi}
        registroId={registroAberto}
        onVoltar={() => { setRegistroAberto(undefined); carregar(); }}
        onSalvo={carregar}
        exibirComercial={false}
        exibirEnderecosExtras={false}
        exibirFrete={true}
        abaExtra={abaExtra}
      />
    );
  }

  return (
    <div>
      <Card style={{ padding: 0, overflow: 'hidden' }}>
        <div style={{ padding: 14, borderBottom: `1px solid ${COLORS.border}`, display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 12 }}>
          <Input placeholder="Buscar por nome ou CNPJ/CPF..." value={busca} onChange={e => setBusca(e.target.value)} style={{ width: 320 }} />
          <Btn onClick={() => setRegistroAberto(null)}>+ Nova Transportadora</Btn>
        </div>
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
          <thead>
            <tr style={{ textAlign: 'left', background: COLORS.bg }}>
              <th style={{ padding: 10 }}>Nome Fantasia</th>
              <th style={{ padding: 10 }}>CNPJ/CPF</th>
              <th style={{ padding: 10 }}>Modal</th>
              <th style={{ padding: 10 }}>Regiões Atendidas</th>
              <th style={{ padding: 10 }}>Status</th>
              <th style={{ padding: 10 }}></th>
            </tr>
          </thead>
          <tbody>
            {transportadoras.map(t => (
              <tr key={t.id} style={{ borderTop: `1px solid ${COLORS.border}` }}>
                <td style={{ padding: 10, cursor: 'pointer' }} onClick={() => setRegistroAberto(t.id)}>{t.nome_fantasia}</td>
                <td style={{ padding: 10 }}>{t.cnpj_cpf || '-'}</td>
                <td style={{ padding: 10 }}>{t.modal_transporte || '-'}</td>
                <td style={{ padding: 10 }}>{t.regioes_atendidas || '-'}</td>
                <td style={{ padding: 10 }}>{t.ativo ? <Badge tom="sucesso">Ativo</Badge> : <Badge tom="perigo">Inativo</Badge>}</td>
                <td style={{ padding: 10, display: 'flex', gap: 8 }}>
                  <Btn tamanho="sm" variante="ghost" onClick={() => setRegistroAberto(t.id)}>Editar</Btn>
                  <Btn tamanho="sm" variante={t.ativo ? 'danger' : 'secondary'} onClick={() => alternarAtivo(t)}>
                    {t.ativo ? 'Desativar' : 'Reativar'}
                  </Btn>
                </td>
              </tr>
            ))}
            {transportadoras.length === 0 && (
              <tr><td colSpan={6} style={{ padding: 20, textAlign: 'center', color: COLORS.textMid }}>Nenhuma transportadora cadastrada ainda.</td></tr>
            )}
          </tbody>
        </table>
      </Card>
    </div>
  );
}
